import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.22543 10.6606C8.32971 10.5438 10 8.80049 10 6.66699C10 4.45785 8.20914 2.66699 6 2.66699C3.79086 2.66699 2 4.45785 2 6.66699C2 7.45413 2.22729 8.18813 2.61993 8.80697L2.33724 9.65502L2.33679 9.65627C2.22852 9.98109 2.17436 10.1436 2.21292 10.2517C2.24653 10.346 2.32112 10.4202 2.41536 10.4539C2.52315 10.4923 2.6845 10.4385 3.00713 10.331L3.01172 10.3296L3.86003 10.0469C4.47887 10.4395 5.2129 10.6669 6.00004 10.6669C6.07568 10.6669 6.15082 10.6648 6.22543 10.6606ZM6.22543 10.6606C6.22548 10.6608 6.22537 10.6605 6.22543 10.6606ZM6.22543 10.6606C6.77271 12.2176 8.25606 13.3338 10.0001 13.3338C10.7872 13.3338 11.5211 13.1062 12.1399 12.7135L12.988 12.9962L12.9897 12.9966C13.3144 13.1048 13.4772 13.1591 13.5854 13.1205C13.6796 13.0869 13.7532 13.0126 13.7869 12.9184C13.8255 12.8101 13.7715 12.6474 13.6629 12.3217L13.3802 11.4736L13.4749 11.3167C13.8092 10.7323 13.9996 10.0552 13.9996 9.33366C13.9996 7.12453 12.2091 5.33366 10 5.33366L9.85026 5.33642L9.77474 5.34011",
      stroke: "#64748B",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }